import angular from 'angular';
import ngRedux from 'ng-redux';
import angularUiBootstrap from 'angular-ui-bootstrap';
import 'angular-gettext';
import 'ui-select';

import 'angular-click-outside';

import apiModule from '../../api/api.module';
import appStateModule from '../../state/state.module';

import { assetSearchComponent, AssetSearchController } from './asset-search.component';
import { assetSearchHistoryComponent, AssetSearchHistoryController } from './history/history.component';

import filterSummary from './history/filter-summary/filter-summary.component';
// import { summaryComponent, SearchSummaryController } from './summary/summary.component';

const assetSearchModule = angular.module('assetSearch', [
	apiModule,
	appStateModule,

	ngRedux,
	angularUiBootstrap,
	'tw.directives.clickOutside',
	'gettext',
	'ui.select'
]);

assetSearchModule

	// Asset Search
	.component('assetSearch', assetSearchComponent)
	.controller('AssetSearchController', AssetSearchController)

	// Search history / favourites
	.component('assetSearchHistory', assetSearchHistoryComponent)
	.component('filterSummary', filterSummary)
	.controller('AssetSearchHistoryController', AssetSearchHistoryController);

export default assetSearchModule.name;
